import type { FC } from "react";
import { Subtitle, WrapContainer } from "../description/description.styles";
import { DescriptionText } from "../../price-page.styles";
import {
  AccordionGroup,
  HelperBlock,
  QuestionsWrapper,
  AccordionTitle,
  AccordionBody,
  QuestionsInner,
} from "./questions.styles";
import { ReactComponent as HelpIcon } from "@src/core/icons/help.svg";
import { Link } from "react-router-dom";
import { Accordion, AccordionDetails, AccordionSummary } from "@mui/material";
import { ReactComponent as ExpandMoreIcon } from "@src/core/icons/expand-more.svg";
import { Button } from "@src/components";
import {APP_ROUTES} from "@src/core/constants";

export const Questions: FC = () => {
    const handleAllQuestions = () => {
        return window.location.replace('/offers');
    }
    const handleOffer = () => {
        return window.location.replace('/offer');
    }

  return (
    <QuestionsWrapper>
      <Subtitle>Частые вопросы</Subtitle>
      <QuestionsInner>
        <WrapContainer>
          <DescriptionText>
            В этом разделе мы собрали ответы на наиболее часто задаваемые
            вопросы, чтобы помочь вам получить нужную информацию быстро и удобно
          </DescriptionText>
          <AccordionGroup>
            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="accordion1"
              >
                <AccordionTitle>
                    Для чего нужен сервис?
                </AccordionTitle>
              </AccordionSummary>
              <AccordionDetails>
                <AccordionBody>
                    Каждый находит в LightBoxAPI свое применение, мы можем сказать для чего мы его используем в своих других проектах. Мы использовали его при интеграции стороннего сервиса, который не предоставлял тестовое окружение, и мы для тестирования создавали API в системе и тестировали интеграцию.
                </AccordionBody>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="accordion2"
              >
                <AccordionTitle>
                    Сервис исключительно платный?
                </AccordionTitle>
              </AccordionSummary>
              <AccordionDetails>
                <AccordionBody>
                    Нет, сервисом можно пользоваться и бесплатно, есть только ряд ограничений по лимитам.
                </AccordionBody>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="accordion3"
              >
                <AccordionTitle>
                    Можно ли использовать сервис для демонстрации своей API?
                </AccordionTitle>
              </AccordionSummary>
              <AccordionDetails>
                <AccordionBody>
                    Да, как одна из опций, если вы хотите сэкономить на аренде и обслуживании сервера под API, вы можете использовать LightBoxAPI для этого.
                </AccordionBody>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="accordion4"
              >
                <AccordionTitle>
                    Возможно ли автоматизировать добавление API?
                </AccordionTitle>
              </AccordionSummary>
              <AccordionDetails>
                <AccordionBody>
                    В LightBoxAPI доступна загрузка файлов документации из swagger и postman. На их основе мы автоматически построим API.
                </AccordionBody>
              </AccordionDetails>
            </Accordion>

            <Accordion>
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel1a-content"
                id="accordion5"
              >
                <AccordionTitle>
                    Поддерживаете ли вы, автозаполнение API, наподобие faker в различных библиотеках?
                </AccordionTitle>
              </AccordionSummary>
              <AccordionDetails>
                <AccordionBody>
                    В данный момент мы работаем над этим, в ближайшее время эта возможность будет добавлена.
                </AccordionBody>
              </AccordionDetails>
            </Accordion>
          </AccordionGroup>
        </WrapContainer>
        <HelperBlock>
          <HelpIcon />
          <div>
              Не нашли нужную информацию? <Link to='/' onClick={handleOffer}>Задайте вопрос</Link>, и мы поможем во всем разобраться!
          </div>
        </HelperBlock>
      </QuestionsInner>
      <Button
        text="Посмотреть все вопросы"
        borderradius="XXXL"
        variant="outlined"
        onClick={handleAllQuestions}
      />
    </QuestionsWrapper>
  );
};
